// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-utilization-table-card {
  overflow: hidden;
  margin-top: 18px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 15px 42px rgba(15, 23, 42, 0.07);
}

.operator-utilization-table-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 22px 16px;
}
.operator-utilization-table-card__header > div > span {
  color: #2f539d;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 1.3px;
}
.operator-utilization-table-card__header h3 {
  margin: 4px 0 3px;
  color: #0f172a;
  font-size: 18px;
  letter-spacing: -0.3px;
}
.operator-utilization-table-card__header p {
  margin: 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.5;
}
.operator-utilization-table-card__header > strong {
  flex-shrink: 0;
  padding: 7px 10px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 14px;
}

.operator-utilization-table-toolbar {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) auto auto;
  gap: 9px;
  padding: 12px 22px;
  border-top: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  background: #fbfdff;
}
.operator-utilization-table-toolbar select {
  min-width: 145px;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  padding: 0 12px;
  outline: none;
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 650;
}
.operator-utilization-table-toolbar select:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.12);
}

.operator-utilization-search {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 11px;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  background: #fff;
}
.operator-utilization-search svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #94a3b8;
  stroke-width: 1.8;
  stroke-linecap: round;
}
.operator-utilization-search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: #0f172a;
  font-size: 11px;
}
.operator-utilization-search input::placeholder {
  color: #94a3b8;
}
.operator-utilization-search:focus-within {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.12);
}

.operator-utilization-table-scroll {
  overflow-x: auto;
}
.operator-utilization-table-scroll table {
  width: 100%;
  min-width: 1240px;
  border-collapse: collapse;
}
.operator-utilization-table-scroll th {
  padding: 11px 12px;
  border-bottom: 1px solid #edf2f7;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  font-weight: 670;
  letter-spacing: 0.45px;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}
.operator-utilization-table-scroll td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #475569;
  font-size: 12px;
  vertical-align: middle;
}
.operator-utilization-table-scroll tbody tr {
  transition: background 160ms ease;
}
.operator-utilization-table-scroll tbody tr:hover {
  background: #fbfdff;
}
.operator-utilization-table-scroll tbody tr:last-child td {
  border-bottom: 0;
}

.operator-person-cell {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 185px;
}
.operator-person-cell strong,
.operator-person-cell small {
  display: block;
}
.operator-person-cell strong {
  max-width: 160px;
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 1px;
}
.operator-person-cell small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
}

.operator-avatar {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 11px;
  background: linear-gradient(135deg, #dbeafe, #e0e7ff);
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 850;
}

.operator-status-pill,
.operator-efficiency-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 8px;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.operator-status-pill i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.operator-status-pill.is-active {
  background: #ecfdf5;
  color: #047857;
}
.operator-status-pill.is-active i {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.12);
}
.operator-status-pill.is-idle {
  background: #f1f5f9;
  color: #64748b;
}
.operator-status-pill.is-idle i {
  background: #94a3b8;
}

.operator-location-cell {
  max-width: 185px;
}
.operator-location-cell strong,
.operator-location-cell small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.operator-location-cell strong {
  color: #334155;
  font-size: 12px;
}
.operator-location-cell small {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 10px;
}

.operator-table-number {
  color: #0f172a;
  font-size: 11px;
}

.operator-mix-cell {
  display: flex;
  gap: 4px;
}
.operator-mix-cell span {
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 750;
}
.operator-mix-cell .ok {
  background: #ecfdf5;
  color: #047857;
}
.operator-mix-cell .reject {
  background: #fef2f2;
  color: #dc2626;
}
.operator-mix-cell .rework {
  background: #fffbeb;
  color: #b45309;
}

.operator-progress-cell {
  min-width: 92px;
  margin: 0px !important;
}
.operator-progress-cell strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
}
.operator-progress-cell > span {
  display: block;
  overflow: hidden;
  height: 4px;
  margin-top: 4px;
  border-radius: 999px;
  background: #e2e8f0;
}
.operator-progress-cell > span i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #10b981, #34d399);
}
.operator-progress-cell.duration > span i {
  background: linear-gradient(90deg, #7c3aed, #a78bfa);
}

.operator-efficiency-pill {
  background: #eef2ff;
  color: #4f46e5;
}

.operator-table-empty {
  padding: 34px !important;
  color: #94a3b8 !important;
  text-align: center;
}

@media (max-width: 760px) {
  .operator-utilization-table-card__header {
    flex-direction: column;
    padding: 18px 14px 14px;
  }
  .operator-utilization-table-toolbar {
    grid-template-columns: 1fr;
    padding: 12px 14px;
  }
  .operator-utilization-table-toolbar select {
    min-height: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/operator-utilization/components/OperatorUtilizationTable.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;AACF;AACE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AACJ;AAEE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAAJ;AAGE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mDAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;AAHF;AAKE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAKI;EACE,qBAAA;EACA,8CAAA;AAHN;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AALF;AAOE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AALJ;AAQE;EACE,WAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AANJ;AAQI;EACE,cAAA;AANN;AAUE;EACE,qBAAA;EACA,8CAAA;AARJ;;AAYA;EACE,gBAAA;AATF;AAWE;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;AATJ;AAYE;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,aAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAXJ;AAcE;EACE,iCAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAeI;EACE,gBAAA;AAbN;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAfF;AAiBE;;EAEE,cAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qDAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlBF;;AAqBA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAlBF;;AAsBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,mBAAA;EACA,cAAA;AApBJ;AAsBI;EACE,mBAAA;EACA,6CAAA;AApBN;AAwBE;EACE,mBAAA;EACA,cAAA;AAtBJ;AAwBI;EACE,mBAAA;AAtBN;;AA2BA;EACE,gBAAA;AAxBF;AA0BE;;EAEE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,cAAA;EACA,eAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA1BJ;;AA8BA;EACE,cAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,QAAA;AA3BF;AA6BE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,cAAA;AA7BJ;AAgCE;EACE,mBAAA;EACA,cAAA;AA9BJ;;AAkCA;EACE,eAAA;EACA,sBAAA;AA/BF;AAiCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA/BJ;AAkCE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAhCJ;AAkCI;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,oDAAA;AAhCN;AAoCE;EACE,oDAAA;AAlCJ;;AAsCA;EACE,mBAAA;EACA,cAAA;AAnCF;;AAsCA;EACE,wBAAA;EACA,yBAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE;IACE,sBAAA;IACA,uBAAA;EAnCF;EAsCA;IACE,0BAAA;IACA,kBAAA;EApCF;EAsCE;IACE,gBAAA;EApCJ;AACF","sourcesContent":[".operator-utilization-table-card {\n  overflow: hidden;\n  margin-top: 18px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 22px;\n  background: #fff;\n  box-shadow: 0 15px 42px rgba(15, 23, 42, 0.07);\n}\n\n.operator-utilization-table-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 22px 16px;\n\n  > div > span {\n    color: #2f539d;\n    font-size: 9px;\n    font-weight: 850;\n    letter-spacing: 1.3px;\n  }\n\n  h3 {\n    margin: 4px 0 3px;\n    color: #0f172a;\n    font-size: 18px;\n    letter-spacing: -0.3px;\n  }\n\n  p {\n    margin: 0;\n    color: #64748b;\n    font-size: 11px;\n    line-height: 1.5;\n  }\n\n  > strong {\n    flex-shrink: 0;\n    padding: 7px 10px;\n    border-radius: 999px;\n    background: #eff6ff;\n    color: #1d4ed8;\n    font-size: 14px;\n  }\n}\n\n.operator-utilization-table-toolbar {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) auto auto;\n  gap: 9px;\n  padding: 12px 22px;\n  border-top: 1px solid #f1f5f9;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fbfdff;\n\n  select {\n    min-width: 145px;\n    border: 1px solid #dbe3ee;\n    border-radius: 10px;\n    padding: 0 12px;\n    outline: none;\n    background: #fff;\n    color: #475569;\n    font-size: 11px;\n    font-weight: 650;\n\n    &:focus {\n      border-color: #60a5fa;\n      box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.12);\n    }\n  }\n}\n\n.operator-utilization-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 0 11px;\n  border: 1px solid #dbe3ee;\n  border-radius: 10px;\n  background: #fff;\n\n  svg {\n    width: 16px;\n    height: 16px;\n    fill: none;\n    stroke: #94a3b8;\n    stroke-width: 1.8;\n    stroke-linecap: round;\n  }\n\n  input {\n    width: 100%;\n    border: 0;\n    outline: none;\n    background: transparent;\n    color: #0f172a;\n    font-size: 11px;\n\n    &::placeholder {\n      color: #94a3b8;\n    }\n  }\n\n  &:focus-within {\n    border-color: #60a5fa;\n    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.12);\n  }\n}\n\n.operator-utilization-table-scroll {\n  overflow-x: auto;\n\n  table {\n    width: 100%;\n    min-width: 1240px;\n    border-collapse: collapse;\n  }\n\n  th {\n    padding: 11px 12px;\n    border-bottom: 1px solid #edf2f7;\n    background: #f8fafc;\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 670;\n    letter-spacing: 0.45px;\n    text-align: left;\n    text-transform: uppercase;\n    white-space: nowrap;\n  }\n\n  td {\n    padding: 12px;\n    border-bottom: 1px solid #f1f5f9;\n    color: #475569;\n    font-size: 12px;\n    vertical-align: middle;\n  }\n\n  tbody tr {\n    transition: background 160ms ease;\n\n    &:hover {\n      background: #fbfdff;\n    }\n\n    &:last-child td {\n      border-bottom: 0;\n    }\n  }\n}\n\n.operator-person-cell {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  min-width: 185px;\n\n  strong,\n  small {\n    display: block;\n  }\n\n  strong {\n    max-width: 160px;\n    overflow: hidden;\n    color: #0f172a;\n    font-size: 12px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    letter-spacing: 1px;\n  }\n\n  small {\n    margin-top: 2px;\n    color: #94a3b8;\n    font-size: 12px;\n  }\n}\n\n.operator-avatar {\n  display: grid;\n  flex-shrink: 0;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 11px;\n  background: linear-gradient(135deg, #dbeafe, #e0e7ff);\n  color: #1d4ed8;\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.operator-status-pill,\n.operator-efficiency-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 999px;\n  padding: 5px 8px;\n  font-size: 12px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.operator-status-pill {\n  i {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n  }\n\n  &.is-active {\n    background: #ecfdf5;\n    color: #047857;\n\n    i {\n      background: #22c55e;\n      box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.12);\n    }\n  }\n\n  &.is-idle {\n    background: #f1f5f9;\n    color: #64748b;\n\n    i {\n      background: #94a3b8;\n    }\n  }\n}\n\n.operator-location-cell {\n  max-width: 185px;\n\n  strong,\n  small {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  strong {\n    color: #334155;\n    font-size: 12px;\n  }\n\n  small {\n    margin-top: 3px;\n    color: #94a3b8;\n    font-size: 10px;\n  }\n}\n\n.operator-table-number {\n  color: #0f172a;\n  font-size: 11px;\n}\n\n.operator-mix-cell {\n  display: flex;\n  gap: 4px;\n\n  span {\n    padding: 4px 6px;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 750;\n  }\n\n  .ok {\n    background: #ecfdf5;\n    color: #047857;\n  }\n\n  .reject {\n    background: #fef2f2;\n    color: #dc2626;\n  }\n\n  .rework {\n    background: #fffbeb;\n    color: #b45309;\n  }\n}\n\n.operator-progress-cell {\n  min-width: 92px;\n  margin: 0px !important;\n\n  strong {\n    color: #0f172a;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  > span {\n    display: block;\n    overflow: hidden;\n    height: 4px;\n    margin-top: 4px;\n    border-radius: 999px;\n    background: #e2e8f0;\n\n    i {\n      display: block;\n      height: 100%;\n      border-radius: inherit;\n      background: linear-gradient(90deg, #10b981, #34d399);\n    }\n  }\n\n  &.duration > span i {\n    background: linear-gradient(90deg, #7c3aed, #a78bfa);\n  }\n}\n\n.operator-efficiency-pill {\n  background: #eef2ff;\n  color: #4f46e5;\n}\n\n.operator-table-empty {\n  padding: 34px !important;\n  color: #94a3b8 !important;\n  text-align: center;\n}\n\n@media (max-width: 760px) {\n  .operator-utilization-table-card__header {\n    flex-direction: column;\n    padding: 18px 14px 14px;\n  }\n\n  .operator-utilization-table-toolbar {\n    grid-template-columns: 1fr;\n    padding: 12px 14px;\n\n    select {\n      min-height: 38px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
